<script>
import { mapGetters } from 'vuex';
import flattenObject from '@/utils/flatten-object';

const { INTERCOM_APP_ID } = process.env;

export default {
  name: 'IntercomWidget',

  props: {
    active: {
      default: true,
      type: Boolean,
    },
  },

  data() {
    return {
      widget: null,
    };
  },

  mounted() {
    this.renderWidget();
  },

  computed: {
    ...mapGetters(['userProfile']),
  },

  watch: {
    active(newValue) {
      if (newValue) {
        this.show();
      } else {
        this.hide();
      }
    },
  },

  methods: {
    renderWidget() {
      const intercomData = this.userProfile ? this.userProfile.third_party_tags_data.intercom : null;
      if (window.intercom && window.intercom.loaded) {
        return;
      }

      if (!intercomData) {
        this.initializeIntercomAnonymous();
      } else {
        window.intercomSettings = flattenObject(intercomData);
        this.initializeIntercom();
      }

      if (!this.active) {
        this.hide();
      }
    },

    initializeIntercomAnonymous() {
      window.intercomSettings = {
        api_base: 'https://api-iam.intercom.io',
        app_id: INTERCOM_APP_ID,
      };
      /* eslint-disable */
          (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
              ic('reattach_activator');
              ic('update', w.intercomSettings);
            } else {
              var d = document;
              var i = function () { i.c(arguments); };
              i.q = [];
              i.c = function (args) { i.q.push(args); };
              w.Intercom = i;
              var l = function () {
                var s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://widget.intercom.io/widget/' + w.intercomSettings.app_id;
                var x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
              };
              if (document.readyState === 'complete') {
                l();
              } else if (w.attachEvent) {
                w.attachEvent('onload', l);
              } else {
                w.addEventListener('load', l, false);
              }
            }
          })();
          /* eslint-enable */
    },

    initializeIntercom() {
      /* eslint-disable */
          (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
              ic('reattach_activator');
              ic('update', w.intercomSettings);
            } else {
              var d = document;
              var i = function () {
                i.c(arguments);
              };
              i.q = [];
              i.c = function (args) {
                i.q.push(args);
              };
              w.Intercom = i;
              var l = function () {
                var s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://widget.intercom.io/widget/' + w.intercomSettings.app_id;
                var x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
              };
              if (document.readyState === 'complete') {
                l();
              } else if (w.attachEvent) {
                w.attachEvent('onload', l);
              } else {
                w.addEventListener('load', l, false);
              }
            }
          })();
          /* eslint-enable */
    },

    show() {
      window.Intercom('update', {
        hide_default_launcher: false,
      });
    },

    hide() {
      window.Intercom('update', {
        hide_default_launcher: true,
      });
    },
  },

  render() {
    return undefined;
  },
};
</script>
